import React from 'react';
import PropTypes from 'prop-types';

class ListItem extends React.Component {
  shouldComponentUpdate = nextProps =>
    this.props.iconClass !== nextProps.iconClass ||
    this.props.isSelected !== nextProps.isSelected ||
    this.props.index !== nextProps.index ||
    this.props.name !== nextProps.name;

  handleClick = e => {
    e.stopPropagation();
    const { select, index } = this.props;
    select(index);
  };

  render() {
    const { isSelected, iconClass, name, itemChildren, identifier, index } = this.props;
    const liProps = {
      className: `dropdownListItem${isSelected ? ' active' : ''}`,
      onClick: this.handleClick,
      role: 'presentation',
    };
    const elements = {
      icon: <i key={`${identifier + index}DropdownIcon`} className={`icon ${iconClass}`} />,
      name: <span key={`${identifier + index}DropdownNameSpan`}>{name}</span>,
    };
    this.childElements = itemChildren.map(el => elements[el]);
    return <li {...liProps}>{this.childElements}</li>;
  }
}

ListItem.defaultProps = {
  iconClass: '',
  isSelected: false,
};

ListItem.propTypes = {
  identifier: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  iconClass: PropTypes.string,
  select: PropTypes.func.isRequired,
  itemChildren: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ListItem;
